import { render, staticRenderFns } from "./ShopConfig.vue?vue&type=template&id=5a318fe8&scoped=true&"
import script from "./ShopConfig.vue?vue&type=script&lang=js&"
export * from "./ShopConfig.vue?vue&type=script&lang=js&"
import style0 from "./ShopConfig.vue?vue&type=style&index=0&id=5a318fe8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a318fe8",
  null
  
)

export default component.exports